export default function WebsiteAsset() {
  return (
    <section className="py-12 sm:py-20 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-4 sm:mb-6 font-['Playfair_Display']">
            Веб-сайт — это высокотехнологичный актив,{' '}
            <span className="hidden sm:inline"><br /></span>
            который приносит прибыль вашему бизнесу
          </h2>
        </div>

        {/* Two Cards */}
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
          {/* Card 1 */}
          <div className="bg-white rounded-3xl p-6 sm:p-10 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-shield-check-line text-2xl sm:text-3xl text-white"></i>
            </div>
            
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Собственный актив против «арендованной» площади
            </h3>
            
            <div className="space-y-4">
              <div>
                <p className="text-sm sm:text-base font-semibold text-[#1A2B4C] mb-2 font-['Montserrat']">
                  <i className="ri-error-warning-line text-[#C5A880] mr-2"></i>
                  Риск:
                </p>
                <p className="text-gray-700 leading-relaxed font-['Montserrat'] text-sm sm:text-base text-justify">
                  Соцсети — это чужая территория. Алгоритмы специально меняются.
                </p>
              </div>
              <div>
                <p className="text-sm sm:text-base font-semibold text-[#1A2B4C] mb-2 font-['Montserrat']">
                  <i className="ri-lightbulb-line text-[#C5A880] mr-2"></i>
                  Решение:
                </p>
                <p className="text-gray-700 leading-relaxed font-['Montserrat'] text-sm sm:text-base text-justify">
                  Сайт — это ваша частная собственность. Вы сами решаете, как представлять товар, какие данные собирать и как управлять вниманием клиента. Это база, которую у вас никто не отберет.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-3xl p-6 sm:p-10 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-filter-3-line text-2xl sm:text-3xl text-white"></i>
            </div>
            
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Сайт как фильтр и квалификатор лидов
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4 italic font-['Montserrat']">
              Не все лиды одинаково полезны.
            </p>
            
            <div className="space-y-4">
              <div>
                <p className="text-sm sm:text-base font-semibold text-[#1A2B4C] mb-2 font-['Montserrat']">
                  <i className="ri-error-warning-line text-[#C5A880] mr-2"></i>
                  Проблема:
                </p>
                <p className="text-gray-700 leading-relaxed font-['Montserrat'] text-sm sm:text-base text-justify">
                  Менеджеры по продажам тратят 80% времени на «пустые» звонки тем, кто «просто спросить».
                </p>
              </div>
              <div>
                <p className="text-sm sm:text-base font-semibold text-[#1A2B4C] mb-2 font-['Montserrat']">
                  <i className="ri-lightbulb-line text-[#C5A880] mr-2"></i>
                  Польза сайта:
                </p>
                <p className="text-gray-700 leading-relaxed font-['Montserrat'] text-sm sm:text-base text-justify">
                  Грамотная структура сайта проводит клиента по стадиям осознания проблемы. К моменту нажатия кнопки «Оставить заявку» клиент уже готов к сделке. Это снижает стоимость привлечения клиентов CAC&nbsp;(Customer
     Acquisition Cost).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}